import { render, staticRenderFns } from "./CodeInvitesOrg.vue?vue&type=template&id=73acfa8e&scoped=true"
import script from "./CodeInvitesOrg.vue?vue&type=script&lang=js"
export * from "./CodeInvitesOrg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73acfa8e",
  null
  
)

export default component.exports